/** @module csi/wizard/StepData */
define([
	"dojo/_base/declare",
	"dojo/_base/lang"
], function(declare,lang) {
	
	const FUTURE = "future";
	const PAST = "past";
	const PRESENT = "present";
	
	const WIZARD_IMAGE = "Image";
	const WIZARD_FORM = "Form";
	const WIZARD_GALLERY = "Gallery";
	const WIZARD_TABLE = "Table";
	
	/**
	 * @typedef {Object} EnteredData
	 * Represents the information object user selected/entered on this step
	 * The format of the object is following:
	 * @property {string[]} names - the name list of user selections
	 */
	
	/**
	 * Holds left pane information for a wizard step
	 */
	const _stepData = declare(null, {
		/** @property {EnteredData} enteredData - the selected/filled information for this step */
		enteredData: null,
		
		/** @property {string} detail - the details information of this step */
		detail: null,
		
		/** @property {number} index - the index of this step */
		index: null,
		
		/** @property {string} subTitle - the subtitle of this step */
		subTitle: null,
		
		/** @property {string} title - the title of this step */
		title: null,
		
		/** @property {string} title - the state of this step
		 * one of past, present, future
		 */
		state: null,
		
		/** @property {string} type - the type of node attached to this step
		 * could be "Image", ...
		 */
		type: null,

		constructor: function(params) {
			lang.mixin(this, params);
			
			this.state = (this.index == 0) ? PRESENT : FUTURE;
		},
		
		/**
		 * Get the entered data of this step
		 * @return {EnteredData}
		 * */
		getEnteredData: function() {
			return this.enteredData;
		},

		/**
		 * Get the single selected name of this node on this step
		 * @return {string}
		 * */
		getName: function() {
			const {enteredData} = this;
			return enteredData.names[0];
		},
		
		/**
		 * Update the entered data on this step
		 * @param {EnteredData} data
		 * */
		setEnteredData: function(data) {
			this.enteredData = this.enteredData || {};
			lang.mixin(this.enteredData, data);
		},
		
		/**
		 * Set the single entered name
		 * @param {string} name
		 * */
		setName: function(name) {
			this.enteredData = this.enteredData || {};
			this.enteredData.names = [name];
		},
		
		FUTURE,
		PAST,
		PRESENT
	});

	_stepData.WIZARD_IMAGE = WIZARD_IMAGE;
	_stepData.WIZARD_FORM = WIZARD_FORM;
	_stepData.WIZARD_GALLERY = WIZARD_GALLERY;
	_stepData.WIZARD_TABLE = WIZARD_TABLE;

	return _stepData;
});
